export const AM_MODULE_NAMESPACE = 'am';
export const AM_CHAR_PBS = 'AM_CHAR_PBS';
export const AM_SET_CHAR_PB_BY_FIELD = 'AM_SET_CHAR_PB_BY_FIELD';
export const AM_RECORD_CHAR_PB = 'AM_RECORD_CHAR_PB';
export const AM_CHAR_PB = 'AM_CHAR_PB';
export const AM_CHAR_PB_TO_EDIT = 'AM_CHAR_PB_TO_EDIT';
export const AM_RESET_CHAR_PB_TO_EDIT = 'AM_RESET_CHAR_PB_TO_EDIT';
export const AM_ACTION = 'AM_ACTION';
export const AM_CHAR_PB_UPDATE = 'AM_CHAR_PB_UPDATE';
export const AM_SET_ATTRIBUTE_BY_FIELD = 'AM_SET_ATTRIBUTE_BY_FIELD';
export const AM_ATTRIBUTE = 'AM_ATTRIBUTE';
export const AM_ATTRIBUTE_TO_EDIT = 'AM_ATTRIBUTE_TO_EDIT';
export const AM_GET_ATTRIBUTE_TYPES = 'AM_GET_ATTRIBUTE_TYPES';
export const AM_SET_ATTRIBUTE_TYPES = 'AM_SET_ATTRIBUTE_TYPES';
export const AM_RECORD_ATTRIBUTE = 'AM_RECORD_ATTRIBUTE';
export const AM_UPDATE_ATTRIBUTE = 'AM_UPDATE_ATTRIBUTE';
export const AM_RECORD_AT_ATTRIBUTE = 'AM_RECORD_AT_ATTRIBUTE';
export const AM_UPDATE_AT_ATTRIBUTE = 'AM_UPDATE_AT_ATTRIBUTE';
export const AM_RESET_ATTRIBUTE_TO_EDIT = 'AM_RESET_ATTRIBUTE_TO_EDIT';
export const AM_ATTACHMENT_TYPES = 'AM_ATTACHMENT_TYPES';
export const AM_ATTACHMENT_TYPE = 'AM_ATTACHMENT_TYPE';
export const AM_ATTACHMENT_TYPE_TO_EDIT = 'AM_ATTACHMENT_TYPE_TO_EDIT';
export const AM_SET_ATTACHMENT_TYPE_BY_FIELD = 'AM_SET_ATTACHMENT_TYPE_BY_FIELD';
export const AM_RECORD_ATTACHMENT_TYPE = 'AM_RECORD_ATTACHMENT_TYPE';
export const AM_ATTACHMENT_TYPE_UPDATE = 'AM_ATTACHMENT_TYPE_UPDATE';
export const AM_RESET_ATTACHMENT_TYPE_TO_EDIT = 'AM_RESET_ATTACHMENT_TYPE_TO_EDIT';
export const AM_CHAR_PB_DELETE = 'AM_CHAR_PB_DELETE';



// WEBPACK FOOTER //
// ./src/store/agency-management/am-types.store.ts